import React, { useEffect, useState } from "react";
import Topbar from "../../../components/Topbar/Topbar";
import {
  delete_icon,
  view_icon,
  edit_icon,
  Search_icon,
  eye_view,
} from "../../../assets/img";
import { useLocation, useNavigate } from "react-router-dom";
import { Table } from "../../../components/Table/Table";
import { get, post } from "../../../Services/ApiHandler";
import { URLS } from "../../../Services/Constant";
import { toast } from "react-toastify";
import { useGlobalContext } from "../../../Services/PaginationGlobal";
import DateRange from "../../../components/DateRange/DateRange";
import Select from "react-select";
import { checkPermission } from "../../redux/api/PermissionManager";
import ReadNotificationPopup from "../../../components/ReadNotificationPopup";
import UnReadNotificationPopup from "../../../components/UnReadNotificationPopup";
import HttpClient from "../../../Services/HttpClient";

function CustomerList() {
  const { paginationData, setpaginationData } = useGlobalContext();
  const location = useLocation();
  const labels = (location?.state?.type && location?.state?.type) || "";

  const [selectedOwners, setSelectedOwners] = useState([]);
  const [showSubmitPopup, setShowSubmitPopup] = useState(false);
  const [submissionDescription, setSubmissionDescription] = useState("");

  const path = location.pathname?.replace("/", "");
  const [label, setIsLabel] = useState(labels || "Profile Details");

  const [pagination, setPagination] = useState({
    current_page: 1,
    last_page: 1,
  });

  const [locationList, setLocationsList] = useState({
    states: [],
    cities: [],
    areas: [],
  });

  const [isViewDetails, setIsViewDetails] = useState({
    ispopUp: false,
    details: {},
  });

  const [count, setCount] = useState(0);
  const [page, setPage] = useState(paginationData?.[path]?.page ?? 1);
  const [search, setSearch] = useState(paginationData?.[path]?.search ?? "");
  const [deletePopup, setDeletePopup] = useState(false);
  const [popup, setPopup] = useState(false);
  const [popupLabel, setPopupLabel] = useState(null);
  const [owners, setOwners] = useState([]);
  const [area, setArea] = useState(null);
  const [city, setCity] = useState(null);
  const [state, setState] = useState(null);
  const [propertyID, setPropertyID] = useState();

  const [propertyList, setPropertyList] = useState([
    {
      "S.No": 1,
      "Booked Date": "12/02/25",
      "Booking ID": "Rob90",
      "Property Name": "Sunshine (2234242342)",
      "No of Booked Rooms": 20,
      "Service Category": "Room Booking",
      "Room Category": "Standart",
      "Property Price": 20000,
      "Paid Amount": 10000,
      Slot: "22 hrs (M) (6am-4am)",
      "Balance Amount": 5000,
      "Current Status": "Up Coming",
      Status: "Booked",
    },
    {
      "S.No": 2,
      "Booked Date": "12/02/25",
      "Booking ID": "Thor91",
      "Property Name": "Sunshine (2234242342)",
      "No of Booked Rooms": 10,
      "Service Category": "Room Booking",
      "Room Category": "Standart",
      "Property Price": 20000,
      "Paid Amount": 10000,
      Slot: "22 hrs (M) (6am-4am)",
      "Balance Amount": null,
      "Current Status": "Checkin",
      Status: "Hold",
    },
    {
      "S.No": 3,
      "Booked Date": "12/02/25",
      "Booking ID": "Thor91",
      "Property Name": "Sunshine (2234242342)",
      "No of Booked Rooms": 10,
      "Service Category": "Room Booking",
      "Room Category": "Standart",
      "Property Price": 20000,
      "Paid Amount": 10000,
      Slot: "22 hrs (M) (6am-4am)",
      "Balance Amount": 10000,
      "Current Status": "Completed",
      Status: "Booked",
    },
    {
      "S.No": 4,
      "Booked Date": "12/02/25",
      "Booking ID": "Thor91",
      "Property Name": "Sunshine (2234242342)",
      "No of Booked Rooms": 10,
      "Service Category": "Room Booking",
      "Room Category": "Standart",
      "Property Price": 20000,
      "Paid Amount": 10000,
      Slot: "22 hrs (M) (6am-4am)",
      "Balance Amount": 10000,
      "Current Status": "Checkin",
      Status: "Booked",
    },
    {
      "S.No": 5,
      "Booked Date": "12/02/25",
      "Booking ID": "Thor91",
      "Property Name": "Sunshine (2234242342)",
      "No of Booked Rooms": 10,
      "Service Category": "Room Booking",
      "Room Category": "Standart",
      "Property Price": 20000,
      "Paid Amount": 10000,
      Slot: "22 hrs (M) (6am-4am)",
      "Balance Amount": 10000,
      "Current Status": "Cancelled",
      Status: "Cancelled",
    },
  ]);

  const [bookingList, setBookingList] = useState([
    {
      SNo: "01",
      TransactionDate: "12/03/25",
      TransactionID: "VOWB00925",
      Property: "Sunshine Villa VOWB00925",
      Owner: "Kumar VOWB00925",
      BookingId: "223322",
      ServiceType: "Room Booking",
      RoomType: "Deluxe",
      City: "Chennai",
      HotelCategory: "Villa",
      PropertyPrice: 1000,
      PaidAmount: 1000,
      BalanceAmount: 50,
      Slot: "22 hrs (M) (9am - 7am)",
      Status1: "Check In",
      Status2: "Booked",
    },
    {
      SNo: "02",
      TransactionDate: "12/03/25",
      TransactionID: "VOWB00925",
      Property: "Sunshine Villa VOWB00925",
      Owner: "Kumar VOWB00925",
      BookingId: "223322",
      ServiceType: "Room Booking",
      RoomType: "Deluxe",
      City: "Chennai",
      HotelCategory: "Villa",
      PropertyPrice: 1000,
      PaidAmount: 1000,
      BalanceAmount: 50,
      Slot: "22 hrs (M) (9am - 7am)",
      Status1: "Check In",
      Status2: "Hold",
    },
    {
      SNo: "03",
      TransactionDate: "12/03/25",
      TransactionID: "VOWB00925",
      Property: "Sunshine Villa VOWB00925",
      Owner: "Kumar VOWB00925",
      BookingId: "223322",
      ServiceType: "Room Booking",
      RoomType: "Deluxe",
      City: "Chennai",
      HotelCategory: "Villa",
      PropertyPrice: 1000,
      PaidAmount: 1000,
      BalanceAmount: 50,
      Slot: "22 hrs (M) (9am - 7am)",
      Status1: "Upcoming",
      Status2: "Booked",
    },
    {
      SNo: "04",
      TransactionDate: "12/03/25",
      TransactionID: "VOWB00925",
      Property: "Sunshine Villa VOWB00925",
      Owner: "Kumar VOWB00925",
      BookingId: "223322",
      ServiceType: "Room Booking",
      RoomType: "Deluxe",
      City: "Chennai",
      HotelCategory: "Villa",
      PropertyPrice: 1000,
      PaidAmount: 1000,
      BalanceAmount: 50,
      Slot: "22 hrs (M) (9am - 7am)",
      Status1: "-",
      Status2: "cancelled",
    },
  ]);

  const [walletList, setWalletList] = useState([
    {
      "S.No": "01",
      State: "Tamil Nadu",
      City: "Chennai",
      "Property ID": "Sunrise Rob90",
      Type: "Cancellation",
      "Booking ID": "33553523",
      Amount: 500,
      "Generated Date": "12/02/25",
      "Created by": "Admin",
      Status: "-",
    },
    {
      "S.No": "02",
      State: "Tamil Nadu",
      City: "Chennai",
      "Property ID": "Sunrise Thor91",
      Type: "Refer & Earn 33553547",
      "Booking ID": "-",
      Amount: 200,
      "Generated Date": "12/02/25",
      "Created by": "-",
      Status: "Expired",
    },
    {
      "S.No": "03",
      State: "Tamil Nadu",
      City: "Chennai",
      "Property ID": "Sunrise Rob90",
      Type: "-",
      "Booking ID": "33553547",
      Amount: 200,
      "Generated Date": "12/02/25",
      "Created by": "-",
      Status: "Not Expired",
    },
    {
      "S.No": "04",
      State: "Tamil Nadu",
      City: "Chennai",
      "Property ID": "Sunrise Thor91",
      Type: "Coupon Vowlove”50”",
      "Booking ID": "33553547",
      Amount: 200,
      "Generated Date": "12/02/25",
      "Created by": "-",
      Status: "Expired",
    },
    {
      "S.No": "05",
      State: "Tamil Nadu",
      City: "Chennai",
      "Property ID": "Sunrise Rob90",
      Type: "Wallet-Check out",
      "Booking ID": "33553547",
      Amount: 200,
      "Generated Date": "12/02/25",
      "Created by": "-",
      Status: "Expired",
    },
    {
      "S.No": "06",
      State: "Tamil Nadu",
      City: "Chennai",
      "Property ID": "Sunrise Thor91",
      Type: "Wallet-Admin",
      "Booking ID": "33553547",
      Amount: 200,
      "Generated Date": "12/02/25",
      "Created by": "Admin",
      Status: "-",
    },
  ]);

  const navigate = useNavigate();

  const [selectedFilter, setSelectedFilter] = useState({
    from: paginationData?.[path]?.from ?? "",
    to: paginationData?.[path]?.to ?? "",
    unread_only: false,
  });

  const handleChangeFilter = (name, val) => {
    if (name !== "from" && val) setPage(1);

    setSelectedFilter((prev) => ({
      ...prev,
      [name]: val,
    }));
  };

  const getLocationsList = async (type, parent_id) => {
    let url = `${URLS.LOCATION}?type=${type}${
      parent_id ? `&parent_id=${parent_id}` : ""
    }`;

    const res = await get(url);

    if (res?.status === "success") {
      const modifiedList = res.data.map((item) => ({
        value: item.id,
        label: item.name,
      }));

      if (type === 2)
        setLocationsList((prev) => ({
          ...prev,
          states: modifiedList,
        }));
      else if (type === 3)
        setLocationsList((prev) => ({
          ...prev,
          cities: modifiedList,
        }));
      else if (type === 4)
        setLocationsList((prev) => ({
          ...prev,
          areas: modifiedList,
        }));
    }
  };

  // Filter effect
  console.log("CCCCIYTTTTT", city, state);

  useEffect(() => {
    const { from, to } = selectedFilter;

    if ((from && to) || (!from && !to)) getList();
  }, [
    selectedFilter.from,
    selectedFilter.to,
    selectedFilter?.unread_only,
    city,
    state,
    area,
  ]);

  const exportExcel = async () => {
    const payload = {
      search,
      from_date: selectedFilter?.from,
      to_date: selectedFilter?.to,
    };

    if (state) {
      payload.state_id = state?.value;
    }

    if (city) {
      payload.city_id = city?.value;
    }

    try {
      let res = await HttpClient.post(URLS.USER_EXPORT_EXCEL, payload, {
        responseType: "blob",
      });

      const blob = new Blob([res.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      const blobUrl = window.URL.createObjectURL(blob);
      const link = document.createElement("a");

      link.href = blobUrl;
      link.download = "CustomerList.xlsx";
      link.click();

      window.URL.revokeObjectURL(blobUrl);
    } catch (error) {
      console.error("excel download failed:", error);
    }
  };

  const handleStatus = async (id, status) => {
    if (!checkPermission("CAN-STATUS-CUSTOMER")) return;

    let payload = {
      status: status === 1 ? 2 : 1,
    };

    const res = await post(URLS.USER_ACTIVE + id + "/status/", payload);

    if (res?.status === "success") {
      toast.success(res?.message || "Status updated");
      getList();
    }
  };

  const getList = async () => {
    const payload = {
      search,
      from_date: selectedFilter?.from,
      to_date: selectedFilter?.to,
    };

    if (state) {
      payload.state_id = state?.value;
    }

    if (city) {
      payload.city_id = city?.value;
    }
    if (area) {
      payload.area_id = area?.value;
    }

    const res = await post(
      `${URLS.USERS_LIST}?page=${page}&unread_only=${selectedFilter?.unread_only}`,
      payload,
    );

    console.log("user list res", res, payload);

    if (res?.status === "success") {
      setOwners(res.data);

      setPagination({
        last_page: res?.total_pages,
        current_page: res?.current_page,
      });

      setCount(res?.count);
    }
  };

  useEffect(() => {
    getList();

    setpaginationData((prev) => ({
      ...prev,
      [path]: {
        page: page,
        search: search,
      },
    }));
  }, [page, search, selectedFilter?.unread_only]);

  // ----------------------------
  // 💡 Label wise Table Columns
  // ----------------------------

  const columnsProfile = [
    {
      Header: "S.No",
      accessor: "S.No",
      Cell: ({ row }) => {
        const pageSize = 10;

        const isSelected = selectedOwners.includes(
          row.original.unread_notification_id,
        );

        const handleCheckboxChange = (e) => {
          if (e.target.checked) {
            setSelectedOwners((prev) => [
              ...prev,
              row.original.unread_notification_id,
            ]);
          } else {
            setSelectedOwners((prev) =>
              prev.filter(
                (id) => id !== row.original.unread_notification_id,
              ),
            );
          }
        };

        return (
          <div
            style={{
              flexDirection: "row",
              alignItems: "center",
              display: "flex",
              gap: 5,
            }}
          >
            <p className="red">
              {row.index + 1 + (page - 1) * pageSize}
            </p>
          </div>
        );
      },
    },
    {
      Header: "User ID",
      accessor: "code",
      Cell: ({ value }) => <p>{value}</p>,
    },
    {
      Header: "Name",
      accessor: "name",
      Cell: ({ value }) => <p>{value}</p>,
    },
    {
      Header: "Email ID",
      accessor: "email",
      Cell: ({ value }) => <p>{value}</p>,
    },
    {
      Header: "Mobile Number",
      accessor: "mobile",
      Cell: ({ value }) => <p>{value}</p>,
    },
    {
      Header: "WhatsUp Number",
      accessor: "whatsapp_no",
      Cell: ({ value }) => <p>{value}</p>,
    },
    {
      Header: "OS / Device Model",
      accessor: "os",
      Cell: ({ value, row }) => {
        const osName = value || "-";
        const deviceModel = row.original.device_model || "-";

        return (
          <p
            className="text-center"
            style={{ textTransform: "capitalize" }}
          >
            {osName} / {deviceModel}
          </p>
        );
      },
    },
    {
      Header: "Gender",
      accessor: "gender",
      Cell: ({ value }) => <p>{value}</p>,
    },
    {
      Header: "State",
      accessor: "state_name",
      Cell: ({ value }) => <p>{value}</p>,
    },
    {
      Header: "City",
      accessor: "city_name",
      Cell: ({ value }) => <p>{value}</p>,
    },
    {
      Header: "Current City/Area",
      accessor: "current_city",
      Cell: ({ value, row }) => (
        <p className={"text-center"}>
          {value} / {row.original.current_area}
        </p>
      ),
    },
    {
      Header: "Pin Code",
      accessor: "pin_code",
      Cell: ({ value }) => (
        <p className={"text-center"}>
          {value ? value : "-"}
        </p>
      ),
    },
    {
      Header: "Booking Count",
      accessor: "booking_count",
      Cell: ({ value }) => (
        <p className={"text-center"}>
          {value ? value : "-"}
        </p>
      ),
    },
    {
      Header: "Status",
      accessor: "status",
      Cell: ({ value, row }) => {
        return (
          <div>
            <button
              onClick={() => {
                handleStatus(row.original?.id, row.original.status);
              }}
              className={`${
                value === 2 ? "deactive-btn" : "active-btn"
              } border-0 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-13`}
            >
              {value === 2 ? "De-active" : " Active"}
            </button>
          </div>
        );
      },
    },
    {
      Header: "Action",
      accessor: "action",
      Cell: ({ row }) => (
        <div className="d-flex ac-js gap-3">
          {checkPermission("CAN-VIEW-CUSTOMER") && (
            <button
              onClick={() => {
                console.log("KKDF", row.original);

                navigate("/customer-view", {
                  state: {
                    type: {
                      ...row.original,
                      ...row.original?.user_details,
                    },
                  },
                });
              }}
              className="cust-btn"
            >
              <img
                src={view_icon}
                alt="View"
                className=" edit-btn"
              />
            </button>
          )}

          {checkPermission("CAN-EDIT-CUSTOMER") && (
            <button
              onClick={() => {
                console.log("KKDF", row.original);

                navigate("/customer-view", {
                  state: {
                    type: {
                      ...row.original,
                      ...row.original?.user_details,
                    },
                  },
                });
              }}
              className="cust-btn"
            >
              <img
                src={edit_icon}
                alt="View"
                className=" edit-btn"
              />
            </button>
          )}

          {checkPermission("CAN-DELETE-CUSTOMER") && (
            <button
              onClick={() => setDeletePopup(row.original.id)}
              className="cust-btn"
            >
              <img
                src={delete_icon}
                alt="Delete"
                className=" edit-btn"
              />
            </button>
          )}
        </div>
      ),
    },
  ];

  const bookingDetail = [
    {
      Header: "S.No",
      accessor: "S.No",
      Cell: ({ row }) => {
        return (
          <p className="red">
            {" "}
            {row.index < 9 ? `${row.index + 1}` : row.index + 1}
          </p>
        );
      },
    },
    {
      Header: "Booked date",
      accessor: "Booked Date",
      Cell: ({ value }) => <p>{value}</p>,
    },
    {
      Header: "Booking Id",
      accessor: "Booking ID",
      Cell: ({ value }) => <p>{value}</p>,
    },
    {
      Header: "Property Name",
      accessor: "Property Name",
      Cell: ({ value }) => (
        <p style={{ color: "#AE55F5" }}>{value}</p>
      ),
    },
    {
      Header: "No of Booked Rooms",
      accessor: "No of Booked Rooms",
      Cell: ({ value }) => <p>{value}</p>,
    },
    {
      Header: "Service Category",
      accessor: "Service Category",
      Cell: ({ value }) => <p>{value}</p>,
    },
    {
      Header: "Room Category",
      accessor: "Room Category",
      Cell: ({ value }) => <p>{value}</p>,
    },
    {
      Header: "Property Price",
      accessor: "Property Price",
      Cell: ({ value }) => <p>{value}</p>,
    },
    {
      Header: "Paid Amount",
      accessor: "Paid Amount",
      Cell: ({ value }) => <p>{value}</p>,
    },
    {
      Header: "Slot",
      accessor: "Slot",
      Cell: ({ value }) => (
        <p style={{ width: "145px" }}>{value}</p>
      ),
    },
    {
      Header: "Balance amount",
      accessor: "Balance Amount",
      Cell: ({ value }) => <p>{value || "-"}</p>,
    },
    {
      Header: "Current Status",
      accessor: "Current Status",
      Cell: ({ value }) => (
        <p
          className="fs-sm-10 fs-md-12 fs-lg-14 fs-xl-13"
          style={{
            background: "#5D5FEF",
            color: "#fff",
            textAlign: "center",
            padding: "10px 20px",
            borderRadius: 9,
            fontSize: "16px",
            cursor: "pointer",
          }}
        >
          {value}
        </p>
      ),
    },
    {
      Header: " Status",
      accessor: "Status",
      Cell: ({ value }) => (
        <p
          className="fs-sm-10 fs-md-12 fs-lg-14 fs-xl-13"
          style={{
            background:
              value == "Booked"
                ? "#5D5FEF"
                : value == "Hold"
                  ? "#FFA721"
                  : "red",
            color: "#fff",
            textAlign: "center",
            padding: "10px 20px",
            borderRadius: 9,
            fontSize: "16px",
            cursor: "pointer",
          }}
        >
          {value}
        </p>
      ),
    },
    {
      Header: "Action",
      accessor: "action",
      Cell: ({ row }) => (
        <div className="d-flex ac-js gap-3">
          <button
            onClick={() => {
              console.log("KKDF", row.original);

              navigate("/booking-list-view", {
                state: {
                  type: {
                    ...row.original,
                    ...row.original?.user_details,
                  },
                },
              });
            }}
            className="cust-btn"
          >
            <img
              src={view_icon}
              alt="View"
              className=" edit-btn"
            />
          </button>
        </div>
      ),
    },
  ];

  const columnsBooking = [
    {
      Header: "S.No",
      accessor: "S.No",
      Cell: ({ row }) => {
        return (
          <p className="red">
            {" "}
            {row.index < 9 ? `${row.index + 1}` : row.index + 1}
          </p>
        );
      },
    },
    {
      Header: "Transaction date",
      accessor: "TransactionDate",
      Cell: ({ value }) => (
        <p className="fs-sm-10 fs-md-12 fs-lg-14 fs-xl-13">
          {value}
        </p>
      ),
    },
    {
      Header: "Transaction Id",
      accessor: "TransactionID",
      Cell: ({ value }) => (
        <p className="fs-sm-10 fs-md-12 fs-lg-14 fs-xl-13">
          {value}
        </p>
      ),
    },
    {
      Header: "Property",
      accessor: "Property",
      Cell: ({ value }) => (
        <p
          className="fs-sm-10 fs-md-12 fs-lg-14 fs-xl-13"
          style={{ color: "#AE55F5" }}
        >
          {value}
        </p>
      ),
    },
    {
      Header: "Owner",
      accessor: "Owner",
      Cell: ({ value }) => (
        <p className="fs-sm-10 fs-md-12 fs-lg-14 fs-xl-13">
          {value}
        </p>
      ),
    },
    {
      Header: "BookingId",
      accessor: "BookingId",
      Cell: ({ value }) => (
        <p className="fs-sm-10 fs-md-12 fs-lg-14 fs-xl-13">
          {value}
        </p>
      ),
    },
    {
      Header: "ServiceType",
      accessor: "ServiceType",
      Cell: ({ value }) => (
        <p className="fs-sm-10 fs-md-12 fs-lg-14 fs-xl-13">
          {value}
        </p>
      ),
    },
    {
      Header: "Property Price",
      accessor: "Property Price",
      Cell: ({ value }) => (
        <p className="fs-sm-10 fs-md-12 fs-lg-14 fs-xl-13">
          {value}
        </p>
      ),
    },
    {
      Header: "RoomType",
      accessor: "RoomType",
      Cell: ({ value }) => (
        <p className="fs-sm-10 fs-md-12 fs-lg-14 fs-xl-13">
          {value}
        </p>
      ),
    },
    {
      Header: "City",
      accessor: "City",
      Cell: ({ value }) => (
        <p className="fs-sm-10 fs-md-12 fs-lg-14 fs-xl-13">
          {value}
        </p>
      ),
    },
    {
      Header: "HotelCategory",
      accessor: "HotelCategory",
      Cell: ({ value }) => (
        <p className="fs-sm-10 fs-md-12 fs-lg-14 fs-xl-13">
          {value}
        </p>
      ),
    },
    {
      Header: "PropertyPrice",
      accessor: "PropertyPrice",
      Cell: ({ value }) => (
        <p className="fs-sm-10 fs-md-12 fs-lg-14 fs-xl-13">
          {value}
        </p>
      ),
    },
    {
      Header: "PaidAmount",
      accessor: "PaidAmount",
      Cell: ({ value }) => (
        <p className="fs-sm-10 fs-md-12 fs-lg-14 fs-xl-13">
          {value}
        </p>
      ),
    },
    {
      Header: "BalanceAmount",
      accessor: "BalanceAmount",
      Cell: ({ value }) => (
        <p className="fs-sm-10 fs-md-12 fs-lg-14 fs-xl-13">
          {value}
        </p>
      ),
    },
    {
      Header: "Slot",
      accessor: "Slot",
      Cell: ({ value }) => (
        <p
          className="fs-sm-10 fs-md-12 fs-lg-14 fs-xl-13"
          style={{ width: "145px" }}
        >
          {value}
        </p>
      ),
    },
    {
      Header: "Status1",
      accessor: "Status1",
      Cell: ({ value }) => {
        console.log("MMMMMMMMMMMMM", value);

        return (
          <p
            className="fs-sm-10 fs-md-12 fs-lg-14 fs-xl-13"
            style={{
              background: value !== "-" ? "#5D5FEF" : "",
              color: value !== "-" ? "#fff" : "#000",
              textAlign: "center",
              padding: "10px 20px",
              borderRadius: 9,
              fontSize: "16px",
              cursor: "pointer",
            }}
          >
            {value || "-"}
          </p>
        );
      },
    },
    {
      Header: "Status",
      accessor: "Status2",
      Cell: ({ value }) => (
        <p
          onClick={() => {
            setPopupLabel(value);
            setPopup(true);
          }}
          className="fs-sm-10 fs-md-12 fs-lg-14 fs-xl-13"
          style={{
            background:
              value == "Booked"
                ? "#5D5FEF"
                : value == "Hold"
                  ? "#FFA721"
                  : "red",
            color: "#fff",
            textAlign: "center",
            padding: "10px 20px",
            borderRadius: 9,
            fontSize: "16px",
            cursor: "pointer",
          }}
        >
          {value}
        </p>
      ),
    },
    {
      Header: "View",
      accessor: "action",
      Cell: ({ row }) => (
        <div className="d-flex ac-js gap-3">
          <button
            onClick={() => {
              console.log("KKDF", row.original);

              navigate("/customer-view", {
                state: {
                  type: {
                    ...row.original,
                    ...row.original?.user_details,
                  },
                },
              });
            }}
            className="cust-btn"
          >
            <img
              src={view_icon}
              alt="View"
              className=" edit-btn"
            />
          </button>
        </div>
      ),
    },
  ];

  const columnsWallet = [
    {
      Header: "S.No",
      accessor: "S.No",
      Cell: ({ row }) => (
        <p>
          {row.index < 9 ? `${row.index + 1}` : row.index + 1}
        </p>
      ),
    },
    {
      Header: "State",
      accessor: "State",
      Cell: ({ value }) => <p>{value}</p>,
    },
    {
      Header: "City",
      accessor: "City",
      Cell: ({ value }) => <p>{value}</p>,
    },
    {
      Header: "Property ID",
      accessor: "Property ID",
      Cell: ({ value }) => <p>{value}</p>,
    },
    {
      Header: "Type",
      accessor: "Type",
      Cell: ({ value }) => <p>{value}</p>,
    },
    {
      Header: "Booking ID",
      accessor: "Booking ID",
      Cell: ({ value }) => <p>{value}</p>,
    },
    {
      Header: "Amount",
      accessor: "Amount",
      Cell: ({ value }) => <p>{value}</p>,
    },
    {
      Header: "Generated Date",
      accessor: "Generated Date",
      Cell: ({ value }) => <p>{value}</p>,
    },
    {
      Header: "Created by",
      accessor: "Created by",
      Cell: ({ value }) => <p>{value}</p>,
    },
    {
      Header: "Status",
      accessor: "Status",
      Cell: ({ value }) => <p>{value}</p>,
    },
  ];

  // ----------------------------
  // 💡 Label wise Data Mapping
  // ----------------------------

  const getActiveData = () => {
    switch (label) {
      case "Profile Details":
        return {
          title: "User List View",
          data: owners,
          columns: columnsProfile,
        };

      case "Booking Detail":
        return {
          title: "Booking Detail",
          data: propertyList,
          columns: bookingDetail,
        };

      case "Booking Transaction":
        return {
          title: "Booking Details",
          data: bookingList,
          columns: columnsBooking,
        };

      case "Wallet Transaction":
        return {
          title: "Wallet Transactions",
          data: walletList,
          columns: columnsWallet,
        };

      default:
        return {
          title: "User List View",
          data: owners,
          columns: columnsProfile,
        };
    }
  };

  const { title, data, columns } = getActiveData();

  const users = [
    { id: 1, name: "Chennai", age: 28, city: "New York" },
    { id: 2, name: "Banglore", age: 34, city: "Los Angeles" },
    { id: 3, name: "Hyderabad", age: 22, city: "Chicago" },
    { id: 4, name: "Nellore", age: 25, city: "Miami" },
    { id: 5, name: "Guntur", age: 40, city: "San Francisco" },
  ];

  const ownerList = [
    { id: 1, name: "John Doe", age: 28, city: "New York" },
    { id: 2, name: "Jane Smith", age: 34, city: "Los Angeles" },
    { id: 3, name: "Sam Brown", age: 22, city: "Chicago" },
    { id: 4, name: "Emily Johnson", age: 25, city: "Miami" },
    { id: 5, name: "Michael Davis", age: 40, city: "San Francisco" },
  ];

  const options = users.map((item) => {
    let obj = {};
    obj.value = item.name;
    obj.label = item.name;
    return obj;
  });

  const handleSumbit = async () => {
    let payload = {
      ids: selectedOwners,
      description: submissionDescription,
    };

    try {
      let url = URLS.NOTIFICATION_COUNTREDUCE;
      let res = await post(url, payload);

      if (res?.status === "success") {
        toast.success("Read Notification has be Success");
        setShowSubmitPopup(false);
        setSubmissionDescription("");
        setSelectedOwners([]);
        getList();
      }
    } catch (error) {
      console.error("Error fetching booking data:", error);
    }

    const res = console.log("Selected Owners:", payload);
  };

  useEffect(() => {
    getLocationsList(2);
  }, []);

  return (
    <>
      <Topbar header={title} subHead={"Customer"} type="view" />

      <div
        style={{
          flexDirection: "row",
          justifyContent: "space-between",
          display: "flex",
          marginBottom: "20px",
        }}
      >
        <div
          className="d-flex mb-4"
          style={{
            flexDirection: "row",
            alignItems: "center",
            gap: 50,
          }}
        >
          <h2 className="f3">Total: {count}</h2>
        </div>

        <div
          style={{
            flexDirection: "row",
            display: "flex",
            alignItems: "center",
            gap: "15px",
          }}
        >
          <Select
            className="location-search"
            options={locationList?.states}
            value={state}
            onChange={(selected) => {
              setLocationsList((prev) => ({
                ...prev,
                cities: [],
                areas: [],
              }));

              if (selected?.value) {
                getLocationsList(3, selected.value);
              }

              setState(selected);
              setCity(null);
              setPage(1);
            }}
            isClearable
            placeholder={"State"}
          />

          <Select
            className="location-search"
            options={locationList?.cities}
            value={city}
            onChange={(selected) => {
              setLocationsList((prev) => ({
                ...prev,
                areas: [],
              }));

              setCity(selected);
              setPage(1);

              if (selected?.value) {
                getLocationsList(4, selected.value);
              }

              setArea(null);
              setPage(1);
            }}
            isClearable
            placeholder={"City"}
          />

          <Select
            className="location-search"
            options={locationList?.areas}
            value={area}
            onChange={(selected) => {
              setArea(selected);
              setPage(1);
            }}
            isClearable
            placeholder={"Area"}
          />

          <button
            onClick={() => exportExcel()}
            className="f2 fs-sm-10 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-16 white add-btn"
            style={{ backgroundColor: "#AE55F5" }}
          >
            {" "}
            Export
          </button>

          {label == "Booking Detail" ? (
            <>
              <Select
                className="location-search"
                options={[{ label: "ASDSA", value: "asdsa" }]}
                value={propertyID}
                onChange={setPropertyID}
                placeholder={" Property ID"}
              />

              <Select
                className="location-search"
                options={options}
                value={city}
                onChange={setCity}
                placeholder={"Booking ID "}
              />
            </>
          ) : label == "Booking Transaction" ? (
            <>
              <Select
                className="location-search"
                options={[{ label: "ASDSA", value: "asdsa" }]}
                value={propertyID}
                onChange={setPropertyID}
                placeholder={" Property ID"}
              />

              <Select
                className="location-search"
                options={options}
                value={city}
                onChange={setCity}
                placeholder={"Room categories "}
              />
            </>
          ) : label == "Wallet Transaction" ? (
            <>
              <Select
                className="location-search"
                options={options}
                value={city}
                onChange={setCity}
                placeholder={"Booking ID"}
              />

              <Select
                className="location-search"
                options={options}
                value={city}
                onChange={setCity}
                placeholder={"State"}
              />

              <Select
                className="location-search"
                options={options}
                value={state}
                onChange={setState}
                placeholder={"City"}
              />
            </>
          ) : (
            <></>
          )}
        </div>
      </div>

      {selectedOwners.length > 0 && (
        <div
          className="f2 fs-sm-10 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-16 white add-btn mt-2"
          style={{ width: 90 }}
          onClick={() => setShowSubmitPopup(true)}
        >
          <p>Submit</p>
        </div>
      )}

      <div className="d-flex ac-jf">
        <div className="search-input">
          <input
            value={search}
            onChange={(e) => {
              setPage(1);
              setSearch(e.target.value);
            }}
            type="text"
            placeholder="Search"
            style={{
              border: "none",
              width: "150px",
            }}
          />

          <img src={Search_icon} className="search" />
        </div>

        <DateRange
          setFromDate={(date) => handleChangeFilter("from", date)}
          setToDate={(date) => handleChangeFilter("to", date)}
        />
      </div>

      <Table
        columns={columns}
        setPageno={setPage}
        pagecount={pagination}
        data={data}
        show={true}
        getRowProps={(row) => ({
          style: {
            backgroundColor: row.original.has_unread_notification
              ? "#eeeeee91"
              : "#fff",
          },
        })}
      />

      {popup && (
        <div className="img-popup-design">
          <div className="img-popup">
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <p className="f3 mt-4" style={{ textAlign: "left" }}>
                {popupLabel} Reason
              </p>

              <div
                style={{ cursor: "pointer" }}
                onClick={() => setPopup(false)}
              >
                <p>X</p>
              </div>
            </div>

            <div
              className="d-flex ac-jb px-2 mt-3"
              style={{ flexDirection: "column" }}
            >
              <textarea
                placeholder="Describe..."
                style={{
                  width: "100%",
                  marginBottom: "1rem",
                  border: "none",
                  background: "#F4F4F4",
                  padding: 10,
                }}
              />

              <button
                onClick={() => setPopup(false)}
                className="back-btn f2 w-40"
              >
                Submit
              </button>
            </div>
          </div>
        </div>
      )}

      {showSubmitPopup && (
        <ReadNotificationPopup
          setSubmissionDescription={setSubmissionDescription}
          setShowSubmitPopup={setShowSubmitPopup}
          submissionDescription={submissionDescription}
          handleSumbit={handleSumbit}
        />
      )}

      {isViewDetails?.ispopUp ? (
        <UnReadNotificationPopup
          setIsViewDetails={setIsViewDetails}
          isViewDetails={isViewDetails}
        />
      ) : (
        <></>
      )}
    </>
  );
}

export default CustomerList;